function vote(isPositive) {
    const method = isPositive ? 'up-vote' : 'down-vote';
    const reviewId = $(this).data('review-id');

    var $wrapper = $(this).closest('.js-review-wrapper');

    $.post(`/api/internal/review/${method}/${reviewId}`, result => {
        $wrapper.find('.js-review-up-vote span', $wrapper).html(result.up);
        $wrapper.find('.js-review-down-vote span', $wrapper).html(result.down);
    });
}

function updateList(page) {
    const $wrapper = $('.js-reviews-list');
    var productId = $wrapper.data('product-id');
    const sort = $('#select-feedbacks-sort').val();

    if (page === undefined) {
        page = $wrapper.data('page');
    }
    $.get(
        `/api/internal/component/catalog:review.list`,
        {
            params: {
                page,
                productId,
                sort,
            },
        },
        result => {
            $wrapper.replaceWith(result);
            $wrapper.data('page', page);
        }
    );
}

/**
 * Показать следующую страницу пагинации отзывов
 */
function initShowMore() {
    $(document).on('click', '.js-review-show-more', () => {
        const $wrapper = $('.js-reviews-list');

        if ($wrapper.data('total-count') < $wrapper.data('page') * $wrapper.data('per-page')) return;
        updateList($wrapper.data('page') + 1);

        $('html, body').animate({ scrollTop: $wrapper.offset().top - 121 }, 200);
    });
}

/**
 * Показать следующую страницу пагинации отзывов
 */
function initShowBack() {
    $(document).on('click', '.js-review-show-prev', () => {
        const $wrapper = $('.js-reviews-list');

        if ($wrapper.data('page') <= 1) return;
        updateList($wrapper.data('page') - 1);

        $('html, body').animate({ scrollTop: $wrapper.offset().top - 121 }, 200);
    });
}

/**
 *
 */
function initSort() {
    const $js = $('#select-feedbacks-sort');
    $js.on('change', function() {
        updateList(1);
    });
}

/**
 * Инициализация отзывов
 */
function initReviews() {
    $(document).on('click', '.js-review-up-vote', function() {
        vote.call(this, true);
    });
    $(document).on('click', '.js-review-down-vote', function() {
        vote.call(this, false);
    });

    initShowMore();
    initShowBack();
    initSort();
}

export default initReviews;
